// extracted by mini-css-extract-plugin
export default {"sidebar":"SideBar_sidebar__8wZMi","iconContainer":"SideBar_iconContainer__tWoGL","active":"SideBar_active__L0zaY","icon":"SideBar_icon__oUmni"};